<template>
  <article class="event-info" v-if="event">
    <Popup message v-if="mountingSchedule" @close="mountingSchedule = false">
      <p
        v-html="
          $t('event.info.installationPeriod', {
            from: installationStartDate.format('DD.MM.YYYY'),
            to: installationEndDate.format('DD.MM.YYYY')
          })
        "
      ></p>

      <p
        v-html="
          $t('event.info.dismantlingPeriod', {
            from: dismantingStartDate.format('DD.MM.YYYY'),
            to: dismantingEndDate.format('DD.MM.YYYY')
          })
        "
      ></p>
    </Popup>

    <div class="event-info__header">
      <h3 class="event-info__header-title">{{ $t("event.info.title") }}</h3>

      <p class="event-info__header-text">{{ eventDescription }}</p>
    </div>

    <ul class="event-info__links" v-if="!isEventMontage">
      <li class="event-info__links-item">
        <a
          :href="conditionLink"
          class="event-info__links-item-link"
          target="_blank"
        >
          {{ $t("event.info.termsLink") }}
        </a>
      </li>
      <li class="event-info__links-item">
        <a
          href="#"
          class="event-info__links-item-link"
          @click="showManagersModal"
        >
          {{ $t("event.info.managersLink") }}
        </a>
      </li>
      <li class="event-info__links-item">
        <a
          :href="standLink"
          target="_blank"
          class="event-info__links-item-link"
        >
          {{ $t("event.info.buildingTypesLink") }}
        </a>
      </li>
      <li class="event-info__links-item">
        <a :href="mapLink" class="event-info__links-item-link" target="_blank">
          {{ $t("event.info.pavilionMapLink") }}
        </a>
      </li>
      <li v-if="participantManual" class="event-info__links-item">
        <a
          href="#"
          @click="downloadParticipantManual"
          class="event-info__links-item-link"
        >
          {{ $t("event.info.participantManual") }}
        </a>
      </li>
    </ul>

    <ul class="event-info__links" v-if="isEventMontage">
      <li class="event-info__links-item">
        <a
          :href="
            `https://www.expocentr.ru/${locale}/exhibitors/participation/#method`
          "
          target="_blank"
          class="event-info__links-item-link"
        >
          {{ $t("event.info.deliveryRulesLink") }}
        </a>
      </li>
      <li class="event-info__links-item">
        <a
          href="#"
          class="event-info__links-item-link"
          @click="$modal.show('event-modal-managers')"
        >
          {{ $t("event.info.organizersLink") }}
        </a>
      </li>
      <li class="event-info__links-item">
        <a
          href="#"
          @click.prevent="mountingSchedule = true"
          class="event-info__links-item-link"
        >
          {{ $t("event.info.mountingScheduleLink") }}
        </a>
      </li>
      <li class="event-info__links-item">
        <a
          :href="`https://www.expocentr.ru/${locale}/fairgrounds/`"
          class="event-info__links-item-link"
          target="_blank"
        >
          {{ $t("event.info.complexSchemeLink") }}
        </a>
      </li>
      <li class="event-info__links-item">
        <a
          :href="
            `https://www.expocentr.ru/${locale}/exhibitors/participation/#booth`
          "
          target="_blank"
          class="event-info__links-item-link"
        >
          {{ $t("event.info.buildingTypesLink") }}
        </a>
      </li>
    </ul>
  </article>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";

import { i18n } from "@v2/shared/config";
import apiParticipant from "@/api/participant";
import { getLocaleValue } from "@/helpers/common";
import { Popup } from "@v2/shared/ui/components";

export default {
  name: "EventInfo",
  components: { Popup },
  data() {
    return {
      mountingSchedule: false
    };
  },
  props: {
    eventId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState("event", ["event"]),
    ...mapGetters("event", ["isEventMontage", "eventPavilion"]),

    locale() {
      return i18n.locale;
    },

    eventDescription() {
      if (!(this.event && this.event.exhibition)) {
        return "";
      }

      return i18n.locale === "en"
        ? this.event.exhibition.description_eng
        : this.event.exhibition.description_rus;
    },

    installationStartDate() {
      let date;
      if (
        this.event &&
        this.event.exhibition &&
        this.event.exhibition.installation_started_at
      ) {
        date = this.event.exhibition.installation_started_at;
      }
      return date ? moment(date) : null;
    },

    installationEndDate() {
      let date;
      if (
        this.event &&
        this.event.exhibition &&
        this.event.exhibition.installation_ended_at
      ) {
        date = this.event.exhibition.installation_ended_at;
      }
      return date ? moment(date) : null;
    },

    dismantingStartDate() {
      let date;
      if (
        this.event &&
        this.event.exhibition &&
        this.event.exhibition.dismantling_started_at
      ) {
        date = this.event.exhibition.dismantling_started_at;
      }
      return date ? moment(date) : null;
    },

    dismantingEndDate() {
      let date;
      if (
        this.event &&
        this.event.exhibition &&
        this.event.exhibition.dismantling_ended_at
      ) {
        date = this.event.exhibition.dismantling_ended_at;
      }
      return date ? moment(date) : null;
    },

    participantManual() {
      return this.event &&
        this.event.exhibition &&
        this.event.exhibition.files &&
        this.event.exhibition.files.length
        ? this.event.exhibition.files.find(
            file => file.type === "guide" && file.lang === i18n.locale
          )
        : null;
    },
    conditionLink() {
      return (
        this.event.exhibition?.website +
        getLocaleValue(this.event.exhibition, "general_terms")
      );
    },
    standLink() {
      return (
        this.event.exhibition?.website +
        getLocaleValue(this.event.exhibition, "stand_construction")
      );
    },
    mapLink() {
      return (
        this.event.exhibition?.website +
        getLocaleValue(this.event.exhibition, "map")
      );
    }
  },

  methods: {
    getLocaleValue,
    showManagersModal(e) {
      e.preventDefault();
      this.$modal.show("event-modal-managers");
    },

    async downloadParticipantManual(e) {
      e.preventDefault();
      if (!this.participantManual) return;
      const response = await apiParticipant.downloadFile(
        this.eventId,
        this.participantManual.id
      );
      if (response) {
        let blob = new Blob([response], {
          type: "application/doc"
        });
        const url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.download = this.participantManual.original_name;
        link.click();
      }
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-info {
  width: 460px;

  box-sizing: border-box;

  padding: 29px 60px 43px 39px;

  @include respond-down(lg) {
    width: 350px;

    padding: 24px 28px;
  }

  @include respond-down(md) {
    padding: 20px 24px 28px 24px;
    margin-bottom: 16px;

    flex-direction: column;
  }

  &__header {
    &-title {
      @include h2();

      font-weight: 500;
      margin-bottom: 19px;

      @include respond-down(md) {
        font-size: 16px;
        margin-bottom: 4px;
      }
    }

    &-text {
      @include description();
    }
  }

  &__links {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    list-style: none;
    margin-top: 20px;

    @include respond-down(md) {
      margin-top: 4px;
      margin-left: 0 !important;
      width: 100% !important;
      flex-wrap: wrap;
    }

    &-item {
      width: 164px;
      margin-top: 19px;

      @include respond-down(md) {
        margin-top: 12px;
      }

      &-link {
        @include hyperlink();

        @include respond-down(md) {
          font-size: 12px;
        }
      }
    }
  }

  &_full-width {
    width: 100%;
    display: flex;
  }

  &_full-width &__links {
    margin-top: 0;
    margin-left: 80px;
    width: 400px;

    &-item {
      width: 184px;

      @include respond-down(xs) {
        width: auto;
      }
    }
  }

  &_full-width &__header {
    max-width: 361px;
  }
}
</style>
